export default "__VITE_ASSET__DG_ePQ_9__"